// @ts-nocheck
import { SocialNetwork } from '../ShareButton';

const translation = {
  SHARE_LABEL: ({ socialNetwork }: { socialNetwork: SocialNetwork }) =>
    `Compartir en ${socialNetwork}`,
};

export default translation;
